import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    backgroundColor: '#F8FAFC', // Forçado fundo cinza claro padrão
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: '100vh',
      overflow: 'auto',
    },
  },
  // Painel Visual Decorativo (Esquerda) - Apenas para md para cima
  visualPane: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    alignItems: 'center',
    padding: theme.spacing(8, 10),
    color: '#F8FAFC',
    position: 'relative',
    overflow: 'hidden',
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    // Fundo Charcoal institucional fixo (sempre escuro no painel esquerdo)
    backgroundColor: '#1E293B',
    borderRight: '1px solid #334155',
  },
  visualContent: {
    position: 'relative',
    zIndex: 2,
    maxWidth: '520px',
  },
  visualSubtitle: {
    color: '#94A3B8',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    marginBottom: theme.spacing(1.5),
  },
  visualTitle: {
    fontWeight: 850,
    lineHeight: 1.2,
    marginBottom: theme.spacing(3),
    fontSize: '2.4rem',
    color: '#F1F5F9',
  },
  visualDesc: {
    color: '#94A3B8',
    fontSize: '1.05rem',
    lineHeight: 1.6,
    marginBottom: theme.spacing(4),
  },
  // Card de Segurança Institucional
  securityCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '12px',
    padding: theme.spacing(3),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  },
  securityItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2.5),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  securityIcon: {
    color: '#F59E0B', // Amarelo/Laranja de alerta fixo
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    marginTop: '3px',
  },
  securityText: {
    fontSize: '0.9rem',
    lineHeight: 1.5,
    fontWeight: 500,
    color: '#E2E8F0',
  },

  // Painel do Formulário (Direita) - Ocupa 100% no mobile e 50% no desktop
  formPane: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    width: '50%',
    padding: theme.spacing(4, 3),
    backgroundColor: '#FFFFFF', // Forçado fundo branco puro
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  formContainer: {
    width: '100%',
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3.5),
  },
  logo: {
    width: '160px',
    height: 'auto',
    filter: 'none', // Fixo preto (sem inversão) para fundo branco
  },
  headerWrapper: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  formTitle: {
    fontWeight: 700,
    color: '#1E293B', // Fixo escuro
    fontSize: '1.75rem',
    marginBottom: theme.spacing(1),
  },
  formSubtitle: {
    color: '#64748B', // Fixo cinza
    fontSize: '0.95rem',
  },
  forgotPasswordLink: {
    display: 'block',
    textAlign: 'center',
    marginTop: theme.spacing(3),
    color: '#0284C7', // Fixo cor de link no modo claro
    fontWeight: 500,
    transition: 'color 0.2s',
    '&:hover': {
      color: '#0EA5E9',
    },
  },
  divider: {
    margin: theme.spacing(4, 0, 3, 0),
    backgroundColor: 'rgba(0, 0, 0, 0.08)', // Fixo divisor sutil claro
  },
  footerWrapper: {
    textAlign: 'center',
    marginTop: 'auto',
    paddingTop: theme.spacing(4),
  },
  footerLogo: {
    width: '130px',
    height: 'auto',
    opacity: 1,
    filter: 'none', // Sem filtros no rodapé
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85,
    },
  },
}))

export default useStyles
